import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Ibge } from 'src/app/models/ibge';
import { VendaEntrega } from 'src/app/models/venda-entrega';
import { ViaCep } from 'src/app/models/viacep';
import { CarregandoService } from 'src/app/services/carregando.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import swal from 'sweetalert2';
import { TipoEnderecoEntrega } from "../../models/enum";
import { FontesConsultaCnpjModel } from "../../dominio/fontes-consulta-cnpj-model";
import { ConsultaCnpjService } from "../../core/services/consulta-cnpj.service";

// jquery
declare const $: any;

@Component({
  selector: "app-venda-endereco-modal",
  templateUrl: "./venda-endereco-modal.component.html",
  styleUrls: ["./venda-endereco-modal.component.scss"],
})
export class VendaEnderecoModalComponent implements OnInit {
  enderecoEntrega = new VendaEntrega();
  tiposDePessoa = [
    { id: 1, nome: "FÍSICA" },
    { id: 0, nome: "JURÍDICA" },
  ];
  estados = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;
  mostrarDadosPessoa = false;
  validarDadosPessoa = false;
  inscricaoEstadualObg = false;
  msgEnderecoAdicional: string;
  ePedido = false;
  bloqueiaAlterecaoEndereco = false;
  buscouCNPJ = false;

  bloquearEdicaoCamposEnderecoEntrega = false;
  ruaBloqueadaCep = false;
  bairroBloqueadoCep = false;
  consultaCepFalhou = false;

  fontesConsultaCnpj: FontesConsultaCnpjModel[] = [];

  public MASKS = MASKS;
  public config: PerfectScrollbarConfigInterface = {};
  constructor(
    public dialogRef: MatDialogRef<VendaEnderecoModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService,
    private viaCepService: ViaCepService,
    private premissasService: PremissasService,
    private consultaCnpjService: ConsultaCnpjService
  ) {
    this.enderecoEntrega = data.enderecoEntrega;
    this.mostrarDadosPessoa = data.mostrarDadosPessoa;
    this.ePedido = Boolean(data.mostrarDadosPessoa);
    this.validarDadosPessoa = data.validarDadosPessoa;
    this.msgEnderecoAdicional = data.msgEnderecoAdicional;
  }

  ngOnInit(): void {
    this.buscarInscricaoEstadualObg();
    this.buscarPremissasSistema();
    this.buscarFontesConsultaCnpj();

    if (!this.mostrarDadosPessoa) {
      if (this.enderecoEntrega !== undefined && this.enderecoEntrega.cep) {
        this.buscarEnderecoPorCep();
      }
    } else {
      if (
        this.enderecoEntrega.uf !== null &&
        this.enderecoEntrega.uf !== undefined
      ) {
        this.estadoSelecionado = this.enderecoEntrega.uf;
      } else {
        this.enderecoEntrega.tipo = 0;
      }
      if (
        this.enderecoEntrega.ibge !== null &&
        this.enderecoEntrega.ibge !== undefined
      ) {
        this.cidadeSelcionado = this.enderecoEntrega.ibge;
      }

      this.buscarCidades();
    }
  }

  buscarInscricaoEstadualObg() {
    this.carregandoService.mostra("buscarInscricaoEstadualObg");
    this.premissasService.consultarInscricaoEstadualObg().subscribe(
      (dados) => {
        this.inscricaoEstadualObg = dados.valor;
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
      },
      (erro) => {
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra("buscaEnderecoPorCep");
    this.viaCepService.obterEndereco(this.enderecoEntrega.cep).subscribe(
      (viaCep: ViaCep) => {
        this.enderecoEntrega.bairro = viaCep.bairro;
        // this.cliente.compl = viaCep.complemento;
        this.enderecoEntrega.rua = viaCep.logradouro;
        this.estadoSelecionado = viaCep.uf;
        this.enderecoEntrega.ibge = Number(viaCep.ibge);

        this.consultaCepFalhou = false;
        this.definirBloqueioCamposCep();
        this.avisarCepIncompleto();

        this.buscarCidades();

        this.focalizaNumero();

        this.carregandoService.esconde("buscaEnderecoPorCep");
      },
      (erro) => {
        this.carregandoService.esconde("buscaEnderecoPorCep");

        this.consultaCepFalhou = true;
        this.definirBloqueioCamposCep();

        if (this.bloquearEdicaoCamposEnderecoEntrega) {
          this.notificacaoService.aviso(
            "Não foi possível localizar o CEP. Confira o CEP informado; Rua e Bairro foram liberados para preenchimento manual."
          );
        } else {
          this.notificacaoService.erro(
            "Não foi possível acessar o serviço de CEP!"
          );
        }
      }
    );
  }

  // Premissa "bloquearEdicaoCamposEnderecoEntrega": Rua e Bairro vêm da consulta de CEP e ficam bloqueados.
  // Ficam liberados quando a consulta falha ou volta sem o dado (CEP genérico).
  definirBloqueioCamposCep() {
    if (!this.bloquearEdicaoCamposEnderecoEntrega || this.consultaCepFalhou) {
      this.ruaBloqueadaCep = false;
      this.bairroBloqueadoCep = false;
      return;
    }

    // Sem UF o CEP ainda não foi consultado: os dois ficam bloqueados até a consulta.
    const cepConsultado = !!this.estadoSelecionado;

    this.ruaBloqueadaCep = !cepConsultado || !!(this.enderecoEntrega.rua || "").trim();
    this.bairroBloqueadoCep = !cepConsultado || !!(this.enderecoEntrega.bairro || "").trim();
  }

  avisarCepIncompleto() {
    if (this.bloquearEdicaoCamposEnderecoEntrega && (!this.ruaBloqueadaCep || !this.bairroBloqueadoCep)) {
      this.notificacaoService.aviso("CEP sem rua e/ou bairro cadastrados. Preencha manualmente os campos liberados.");
    }
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra("buscaCidades");
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe(
      (ibges: Ibge[]) => {
        this.cidades = ibges;

        if (nomeCidade) {
          this.cidadeSelcionado = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(
                s.cidade.toLowerCase().trim()
              ) ===
              this.utilitarioService.remover_acentos_espaco(
                nomeCidade.toLowerCase().trim()
              )
          )
            ? this.cidades.find(
                (s) =>
                  this.utilitarioService.remover_acentos_espaco(
                    s.cidade.toLowerCase().trim()
                  ) ===
                  this.utilitarioService.remover_acentos_espaco(
                    nomeCidade.toLowerCase().trim()
                  )
              ).cod
            : undefined;
        } else {
          if (
            this.enderecoEntrega.ibge !== undefined &&
            this.enderecoEntrega !== null
          ) {
            this.cidadeSelcionado = this.cidades.find(
              (s) => s.cod === this.enderecoEntrega.ibge.toString()
            )
              ? this.cidades.find(
                  (s) => s.cod === this.enderecoEntrega.ibge.toString()
                ).cod
              : "";
          } else {
            this.cidadeSelcionado = undefined;
          }
        }

        this.carregandoService.esconde("buscaCidades");
      },
      (erro) => {
        this.carregandoService.esconde("buscaCidades");
      }
    );
  }

  focalizaNumero() {
    $("#numero").focus();
  }

  consultarCnpj(idFonte: string | null = null) {
    this.carregandoService.mostra("consultarCnpj");

    this.consultaCnpjService
      .consultar(this.enderecoEntrega.cpfCnpj, idFonte)
      .subscribe(
        (data) => {
          const resultado = data.result;

          let telefone: string | null = null;

          if (resultado.telefones && resultado.telefones.length > 0) {
            telefone = resultado.telefones[0];
          }

          let email: string | null = null;

          if (resultado.emails && resultado.emails.length > 0) {
            email = resultado.emails[0];
          }

          this.enderecoEntrega.cpfCnpj = resultado.cnpj;
          this.enderecoEntrega.nome = resultado.razaoSocial;

          this.enderecoEntrega.rua = resultado.logradouro;
          this.enderecoEntrega.numero = resultado.numero != null ? resultado.numero : this.enderecoEntrega.numero;
          this.enderecoEntrega.complemento = resultado.complemento != null ? resultado.complemento : this.enderecoEntrega.complemento;
          this.enderecoEntrega.bairro = resultado.bairro;
          this.enderecoEntrega.ibge = undefined;
          this.estadoSelecionado = resultado.uf;
          this.enderecoEntrega.cep = resultado.cep;

          this.buscarCidades(resultado.cidade);

          this.enderecoEntrega.celular = telefone != null ? telefone : this.enderecoEntrega.celular;
          this.enderecoEntrega.email = email != null ? email : this.enderecoEntrega.email;
          this.buscouCNPJ = true;

          // Endereço vindo da Receita segue a mesma regra do CEP: bloqueia o que veio preenchido.
          this.consultaCepFalhou = false;
          this.definirBloqueioCamposCep();

          this.carregandoService.esconde("consultarCnpj");
        },
      (erro) => {
        this.carregandoService.esconde("consultarCnpj");
        this.notificacaoService.erro(erro);      }
    );
  }

  voltar() {
    this.dialogRef.close();
  }

  salvar(validar: boolean = true) {
    if (validar) {
      if (this.validarDadosPessoa && this.enderecoEntrega.tipo === 0 && !this.buscouCNPJ) {
        const habilitaConsultaRapida = this.fontesConsultaCnpj.length == 1;
        const textoMensagem = habilitaConsultaRapida
          ? "É necessário atualizar os dados do CNPJ informado. Deseja consultar agora?"
          : "É necessário atualizar os dados do CNPJ informado.";
        const textoBotao = habilitaConsultaRapida ? "Consultar" : "Ok";

        swal({
          title: "Atenção!!",
          text: textoMensagem,
          type: "warning",
          showCancelButton: habilitaConsultaRapida,
          confirmButtonClass: "btn btn-info",
          confirmButtonText: textoBotao,
          cancelButtonClass: "btn btn-danger",
          cancelButtonText: "Não",
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            if (this.fontesConsultaCnpj.length === 1) {
              this.consultarCnpj(this.fontesConsultaCnpj[0].id);
            } else {
              // Existem múltiplas fontes de consulta, então ela tem que ser feita manualmente
            }
          }
        });

        return;
      }

      if (this.msgEnderecoAdicional != "") {
        swal({
          title: "Atenção!!",
          text: this.msgEnderecoAdicional,
          type: "warning",
          showCancelButton: false,
          confirmButtonClass: "btn btn-info",
          confirmButtonText: "Ok",
          buttonsStyling: false,
        }).then(() => {
          this.salvar(false);
        });

        return;
      }
    }

    this.enderecoEntrega.uf = this.estadoSelecionado;
    this.enderecoEntrega.ibge = this.cidadeSelcionado;
    this.enderecoEntrega.cidade = this.cidades.find(
      (s) => s.cod === this.enderecoEntrega.ibge.toString()
    )
      ? this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge.toString())
          .cidade
      : "";
    this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.Personalizado;

    this.dialogRef.close(this.enderecoEntrega);
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra("buscarPremissasSistema");

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.bloqueiaAlterecaoEndereco =
          premissas.bloquearAlteracaoNovoEnderecoEntregaCNPJ;
        this.bloquearEdicaoCamposEnderecoEntrega =
          premissas.bloquearEdicaoCamposEnderecoEntrega;
        this.definirBloqueioCamposCep();
        this.carregandoService.esconde("buscarPremissasSistema");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissasSistema");
        this.notificacaoService.erro(erro);
      }
    );
  }

  validarBuscaCNPJ() {
    this.buscouCNPJ = false;
  }

  limparClienteFaturamento(tipo: number) {
    this.enderecoEntrega = new VendaEntrega();
    this.enderecoEntrega.tipo = tipo;
    this.cidadeSelcionado = undefined;
    this.estadoSelecionado = undefined;
  }

  buscarFontesConsultaCnpj() {
    this.carregandoService.mostra("buscarFontesConsultaCnpj");

    this.consultaCnpjService.buscarFontes().subscribe(
      (data) => {
        this.fontesConsultaCnpj = data.results;
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
        this.notificacaoService.erro(erro);
      }
    );
  }

  limpar() {
    this.enderecoEntrega.rua = '';
    this.enderecoEntrega.numero = '';
    this.enderecoEntrega.complemento = '';
    this.enderecoEntrega.bairro = '';
    this.enderecoEntrega.uf = '';
    this.enderecoEntrega.cidade = '';
    this.estadoSelecionado = undefined;
    this.cidadeSelcionado = undefined;

    this.consultaCepFalhou = false;
    this.definirBloqueioCamposCep();
  }
}
